import {
  EnumMultiDropdown,
  EnumMultiDropdownCreateForm,
  PureEnumMultiDropdownField,
  PureEnumMultiDropdownFieldProps,
} from './EnumMultiDropdown';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants';
import { translate } from '../../helpers';

const fieldName = ISSUE_ATTRIBUTE_NAMES.CATEGORY; // 'category'

export const CategoryFormikField = () => (
  <EnumMultiDropdown
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const CategoryInCreateForm = () => (
  <EnumMultiDropdownCreateForm
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={fieldName}
    clearable
  />
);

export const CategoryField = ({
  value,
  onChange,
  disabled = false,
  'data-testid': dataTestId,
}: Pick<PureEnumMultiDropdownFieldProps, 'value' | 'onChange' | 'disabled' | 'data-testid'>) => (
  <PureEnumMultiDropdownField
    fieldName={fieldName}
    label={translate(`new.${fieldName}`)}
    placeholder={translate(`new.placeholder.${fieldName}`)}
    id={`inline-${fieldName}`}
    value={value}
    onChange={onChange}
    disabled={disabled}
    clearable
    data-testid={dataTestId}
  />
);
